import { render, staticRenderFns } from "./topic_detail_data_relation.vue?vue&type=template&id=c6c4ac32"
import script from "./topic_detail_data_relation.vue?vue&type=script&lang=js"
export * from "./topic_detail_data_relation.vue?vue&type=script&lang=js"
import style0 from "./topic_detail_data_relation.vue?vue&type=style&index=0&id=c6c4ac32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports